/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React, {FC, memo} from 'react';
import {BaseAsset} from '@ion/core/src/types/entities';
import AssetEventPopupContent from './AssetEventPopupContent';
import SCDeviceEventPopupContent from './SCDeviceEventPopupContent';

/**
 * Defines the EventPopup component which renders the default Event PopUp
 * in reports page on hovering corresponding points on the map.
 */

export interface EventPopup {
  selectedAsset: BaseAsset;
  hasIOnVision?: boolean;
  skipSpeed?: boolean;
  setIONVision?: Function;
  streetViewClick?: Function | null;
}

export const EventPopup: FC<EventPopup> = ({
  selectedAsset,
  hasIOnVision,
  setIONVision,
  streetViewClick,
  skipSpeed = false
}) => {
  const {isScDevice = false} = selectedAsset || {};

  return !isScDevice ? (
    <AssetEventPopupContent selectedAsset={selectedAsset}
      setIONVision={setIONVision}
      hasIOnVision={hasIOnVision}
      streetViewClick={streetViewClick}
      skipSpeed={skipSpeed} />
  ) : (
    <SCDeviceEventPopupContent selectedAsset={selectedAsset} />
  );
};

export default memo(EventPopup);
